<template>
  <div class="columns is-centered is-mobile">
    <div class="column login-form-wrapper">
      <div class="login-form">
        <div class="login-form__icon">
          <b-icon pack="far" icon="user-circle"></b-icon>
        </div>
        <div class="login-form__title">Reset your password</div>
        <div class="login-form__subtitle">Please enter your email address.
          If you already have an account, we will send you a link to reset your password.</div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="login-form__item">
              <ValidationProvider name="Email" v-slot="{ errors }" rules="required|email">
                <b-field label="Email"
                         class="email-field"
                         :type="{ 'is-danger':errors.length }"
                         :message="errors">
                  <b-input size="is-medium"
                           v-model.trim="local_email"
                           custom-class="input-email"
                           placeholder="Enter your email address"
                           maxlength="250"></b-input>
                </b-field>
              </ValidationProvider>
              <div class="login-form__item">
                <p class="control">
                  <button class="button is-success submit-button" type="submit">
                    CONTINUE
                  </button>
                </p>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import * as MUTATIONS from '../store/mutations';
import * as AUTH_ACTIONS from '../store/modules/auth/actions';

export default {
  name: 'RestorePassword',
  props: {
    email: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      local_email: this.email,
      message: '',
    };
  },

  computed: {
  },

  methods: {
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),
    ...mapActions('auth2', {
      restorePassword: AUTH_ACTIONS.RESTORE_PASSWORD,
    }),

    async submit() {
      this.preloader(true);
      this.restorePassword({ email: this.local_email })
        .then((response) => {
          this.$buefy.toast.open({
            message: this.lodash.get(response, 'message', 'Success'),
            type: 'is-success',
            position: 'is-top',
            duration: 5000,
          });
          this.$router.push('/login');
        }).catch((error) => {
          this.$buefy.toast.open({
            message: this.lodash.get(error, 'response.data.message', 'Undefined error'),
            type: 'is-danger',
            duration: 5000,
          });
        }).finally(() => this.preloader(false));
    },
  },

};
</script>

<style scoped lang="stylus">
@require "../assets/style/modern/variables.styl";
.login-form-wrapper >>> .input-email
  font-size 16px
  height 48px
.email-field >>> span.icon
  height 48px
.login-form-wrapper
  display flex
  justify-content center
  padding-right 0
  .login-form
    @media (max-width: $breakpoints.md)
      padding 30px 16px
    max-width 750px
    margin 20px 20px 0 20px
    width 100%;
    background white
    border-radius 6px
    padding 30px 55px
    box-shadow 0 18px 32px rgba(156, 173, 173, 0.2);
    color #293033
    &__icon, &__title, &__subtitle, &__subtitle_bold
      text-align center
    &__item
      margin-bottom 10px
      p.control
        text-align center
    &__icon
      margin-bottom 15px
      color: #17B548
      font-size 2rem
    &__title
      font-weight bold
      font-size 28px
      margin-bottom 10px
      color #293033
    &__subtitle, &__subtitle_bold
      margin-bottom 30px
      font-size 18px
      color #293033
    &__subtitle_bold
      font-weight bold
    &__link
      color #188DFC
      text-align center
      & a
        color #188DFC
        margin 0 10px
        &:hover
          text-decoration underline
  .submit-button
    font-size 20px
    height 48px
    margin-top 5px
    background #68BA62
    max-width 240px
    min-width 100px
    width 100%
    @media (max-width: $breakpoints.md)
      font-size 16px
      max-width unset
      min-width unset
  .login
    background #0743bf1c
    padding 15px
    border-radius 6px
  .help-pass
    z-index -999999
    position absolute
    margin-top -50px
    border none
    color transparent
</style>
